export default "__VITE_ASSET__BVXzB16x__"